import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-filter-dialog",
    style: _ctx.descriptor.entityRelation.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary kn-width-full" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.parameters')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_KnFabButton, {
            icon: "fas fa-plus",
            onClick: _ctx.addNewParam
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _ctx.cancelChanges
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: _ctx.hasDuplicates,
        onClick: _ctx.saveParameters
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.hasDuplicates)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            class: "p-mx-2",
            severity: "info",
            closable: false
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('qbe.detailView.parameterDuplicates')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_DataTable, {
        class: "p-datatable-sm kn-table p-m-2",
        value: _ctx.dataset.pars,
        responsiveLayout: "scroll"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.tableEmpty')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            header: _ctx.$t('kpi.alert.name'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: data.name,
                "onUpdate:modelValue": ($event: any) => (data.name = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "type",
            header: _ctx.$t('kpi.alert.type'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_Dropdown, {
                id: "scope",
                class: "kn-material-input",
                options: _ctx.datasetParamTypes,
                optionLabel: "name",
                optionValue: "value",
                modelValue: data.type,
                "onUpdate:modelValue": ($event: any) => (data.type = $event)
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "defaultValue",
            header: _ctx.$t('managers.driversManagement.useModes.defaultValue'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: data.defaultValue,
                "onUpdate:modelValue": ($event: any) => (data.defaultValue = $event),
                onChange: ($event: any) => (_ctx.onDefaultValueChange(data))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "multiValue",
            header: _ctx.$t('managers.profileAttributesManagement.form.multiValue'),
            sortable: true
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_Checkbox, {
                modelValue: data.multiValue,
                "onUpdate:modelValue": ($event: any) => (data.multiValue = $event),
                binary: true
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, { onRowClick: false }, {
            header: _withCtx(() => [
              _createVNode(_component_Button, {
                icon: "fas fa-eraser",
                class: "p-button-link",
                onClick: _ctx.removeAllParams
              }, null, 8, ["onClick"])
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_component_Button, {
                icon: "fas fa-trash",
                class: "p-button-link",
                onClick: ($event: any) => (_ctx.deleteParam(slotProps))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}